import { AnimationPreviewManager } from "./manager";

export { AnimationPreviewManager } from "./manager";

export function initAnimationPreview() {
  return new AnimationPreviewManager();
}
